import { WithRouterProps } from 'next/dist/client/with-router';
import { SingletonRouter, withRouter } from 'next/router';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import Merchant from '../../../domain/entities/Merchant';
import Button, { ButtonSize } from '../../common/buttons/Button';
import { reservationUrlBy } from './helper';

import css from './MerchantReservationButton.module.scss';

interface OwnProps {
  router?: SingletonRouter;
  merchant: Merchant;
}

type Props = OwnProps & InjectedIntlProps & WithRouterProps;

const MerchantReservationButton = ({ merchant, intl, router }: Props) => {
  const reservationUrl = reservationUrlBy(merchant, router);
  return (
    <Button
      className={css.MerchantReservationButton}
      buttonSize={ButtonSize.Medium}
      href={reservationUrl.url}
      target={reservationUrl.targetBlank ? '_blank' : undefined}
    >
      {intl.formatMessage({
        id: 'merchants.merchantReservationButton.submit',
      })}
    </Button>
  );
};

export default injectIntl(withRouter(MerchantReservationButton));
